import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  additionalLanguages: {
    id: 'settings.change-language-form-section.additional-languages-title',
    defaultMessage: 'Additional languages',
  },
  additionalLanguagesDescription: {
    id: 'settings.change-language-form-section.additional-languages-description',
    defaultMessage: 'More languages will be available in the future.',
  },
  title: {
    id: 'settings.change-language-form-section.title',
    defaultMessage: 'Change language',
  },
  translation: {
    id: 'settings.change-language-form-section.translation-title',
    defaultMessage: 'Translation',
  },
  translationDescription: {
    id: 'settings.change-language-form-section.translation-description',
    defaultMessage:
      'We’ll translate the most important information for your browsing, and booking. Our translations are provided for your convenience. The English version of ClassPass, including our Conditions of Use, is the definitive version.',
  },
});
